import { CustomButtonStyles } from "../types/MuiTheme";

export const HSV_BRAND_COLORS = {
    blue: "#1E5CB3",
    blueRgb: "rgb(30, 92, 179)",
    white: "#FFFFFF",
    black: "#000000",
    blueDark: "#013263",
    blueLight: "#6FB2DB",
    blueAlpha: "rgba(30, 92, 179, 0.1)",

    nxpOrange: "#FCA600",

    primary: "#1E5CB3",
    secondary: "#0a3f86",
    accent: "#4A7BC8",

    hover: "#0068c4",
    active: "#005aaa",
    disabled: "#B8BCC8",

    backgroundPrimary: "rgba(255, 255, 255, 0.95)",
    backgroundSecondary: "rgba(255, 255, 255, 0.85)",
    backgroundDark: "rgba(0, 0, 0, 0.7)",

    linkPrimary: "#FFFFFF",
    linkSecondary: "#f8f9fa",
    linkHover: "#e9ecef",
    linkSecondaryHover: "#dee2e6",

    textOnBlue: "#FFFFFF",
    textOnWhite: "#000000",
    textMuted: "#666666",
    textPrimary: "#1E5CB3",
};

export const BUTTON_STYLES = {
    cta: createButtonStyles({
        bgColor: HSV_BRAND_COLORS.active,
        hoverColor: HSV_BRAND_COLORS.hover,
        borderColor: HSV_BRAND_COLORS.active,
        hoverBorderColor: HSV_BRAND_COLORS.hover,
    }),
    primary: createButtonStyles({
        bgColor: HSV_BRAND_COLORS.primary,
        hoverColor: HSV_BRAND_COLORS.accent,
        borderColor: HSV_BRAND_COLORS.primary,
        hoverBorderColor: HSV_BRAND_COLORS.accent,
    }),
    secondary: createButtonStyles({
        bgColor: HSV_BRAND_COLORS.secondary,
        hoverColor: HSV_BRAND_COLORS.blueDark,
        borderColor: HSV_BRAND_COLORS.secondary,
        hoverBorderColor: HSV_BRAND_COLORS.blueDark,
    }),
};

function createButtonStyles(params: {
    bgColor: string;
    hoverColor: string;
    borderColor: string;
    hoverBorderColor: string;
}): CustomButtonStyles {
    return {
        backgroundColor: params.bgColor,
        color: HSV_BRAND_COLORS.textOnBlue,
        borderColor: params.borderColor,
        border: `2px solid ${params.borderColor}`,
        borderRadius: "8px",
        fontWeight: "bold",
        textTransform: "none",
        boxShadow: "0 2px 8px rgba(30, 92, 179, 0.2)",
        transition: "all 0.3s ease",
        "&:hover": {
            backgroundColor: params.hoverColor,
            color: HSV_BRAND_COLORS.textOnBlue,
            borderColor: params.hoverBorderColor,
            boxShadow: "0 4px 16px rgba(30, 92, 179, 0.3)",
            transform: "translateY(-1px)",
        },
        "&:active": {
            transform: "translateY(0)",
            boxShadow: "0 2px 8px rgba(30, 92, 179, 0.2)",
        },
    };
}
